import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import { Button } from '../../styles/customComponents';

const ErrorHandler = props => {
  return (
    <styles.ConnectionError>
      <styles.BrokenLink />
      {props.children}
      <Button id="btnConnectionError" onClick={() => window.location.reload()}>
        Recarregar Página
      </Button>
    </styles.ConnectionError>
  );
};

ErrorHandler.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/components/ErrorHandler/index.js